<script >import { classNames, css, renameProps } from './utils';
let _class = '';
export { _class as class };
export let inline = false;
export let reverse = false;
export let width = false;
export let height = false;
export let style = {};
export let use = (node) => { };
</script>

<div
	use:css={renameProps(style)}
	class={classNames(_class, { inline, reverse, width, height }, 'layout')}
	use:use
>
	<slot />
</div>

<style>
	.layout.row,
	.layout.col {
		display: flex;
	}
	.layout.row.inline {
		display: inline-flex;
	}
	.layout.col.inline {
		display: inline-flex;
	}
	.layout.row {
		flex-direction: row;
	}
	.layout.row.reverse {
		flex-direction: row-reverse !important;
	}
	.layout.col {
		flex-direction: column;
	}
	.layout.col.reverse {
		flex-direction: column-reverse !important;
	}

	.layout.grid {
		display: grid;
	}
	.layout.grid.inline {
		display: inline-grid;
	}

	.layout.width {
		width: 100%;
	}
	.layout.height {
		height: 100%;
	}

	.layout.item {
		display: block;
	}
	.layout.items.inline {
		display: inline-block;
	}
</style>
